(function (global) {
  'use strict';

  // `logginn` er ikke en side — det er merket avloggingen setter for at app.jsx
  // skal tegne innloggingsskjermen. Merket blir liggende i `route`, og i
  // `plumme-route`, nar noen logger inn igjen i samme fane uten a laste siden pa
  // nytt. Da finner Shell ingen komponent for ruten og tegner «Denne siden er pa
  // vei». `normalizeStoredRoute` vasker merket ved oppstart; dette er den samme
  // vasken for okten som aldri startet pa nytt.
  const SIGNED_OUT_ROUTE = 'logginn';

  // Kalles bare fra effekten som er keyet pa uid, altsa pa en auth-overgang.
  // `currentUserId` ma vaere satt: mellom `signOut()` og at `onAuthStateChanged`
  // har tomt `backend.user` staar ruten allerede pa merket, og en reset der ville
  // dratt brukeren til `hjem` midt i sin egen utlogging.
  const shouldResetRouteForUser = ({ previousUserId, currentUserId, route } = {}) =>
    Boolean(currentUserId && (
      (previousUserId && previousUserId !== currentUserId)
      || route === SIGNED_OUT_ROUTE
    ));

  const loadingTranslationKey = ({ route, personalFinance = false } = {}) => {
    if (route === 'ansattportal') return 'app.loadingEmployeePortal';
    if (route === 'privatokonomi' || personalFinance) return 'app.loadingPersonalFinance';
    // Byraaflaten laster ikke DITT regnskap — den laster byraaet ditt, og som
    // regel ikke et regnskap i det hele tatt. Noekkelen ligger i
    // src/i18n/locale-firm-*.js, som er lest for splashen males.
    if (route === 'regnskapsforer') return 'rf.loading.firm';
    return 'app.loading';
  };

  global.PlummeSessionRoute = { shouldResetRouteForUser, loadingTranslationKey };
})(typeof window !== 'undefined' ? window : globalThis);
